function onCartChange(callback) {
  const targets = [
    document.querySelector('#CartDrawer'),
    document.querySelector('#CartPage')
  ].filter(Boolean);

  if (targets.length === 0) {
    console.warn("❌ Cart drawer/page not found!");
    return;
  }

  let timer;

  targets.forEach((target) => {
    const observer = new MutationObserver(() => {
      if (!target.classList.contains('is-cart-loading')) {
        clearTimeout(timer);
        timer = setTimeout(() => {
          callback(target);
        }, 150);
      }
    });

    observer.observe(target, { attributes: true, attributeFilter: ['class'] });
  });
}

onCartChange((el) => {
  console.log("🛒 Cart drawer updated!");
  FreeShippingBarUpdator( el );
});

function FreeShippingBarUpdator( el ) {
  if (el.id === "CartDrawer") {
    console.log("👉 Drawer ka cart update hua!");
    if ( $( `free-shipping-module-placement` ).length > 0 ) {
      $.get( `/cart?view=free-shipping-car`, function ( res ) {
        $( `free-shipping-module-placement` ).html( res );
      });
    }
  } else if (el.id === "CartPage") {
    console.log("👉 Page ka cart update hua!");
  }
}
